import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './Panel.scss';

class Panel extends Component {
  componentDidMount() {
    if (this.props.isOpen && (__TEST__ || __CLIENT__)) {
      document.body.addEventListener('click', this.handleOutsideClick);
      document.body.addEventListener('keydown', this.handleKeydown);
    }
  }

  componentDidUpdate(prevProps) {
    const { isOpen } = this.props;

    if (isOpen && !prevProps.isOpen) {
      if (__TEST__ || __CLIENT__) {
        document.body.addEventListener('click', this.handleOutsideClick);
        document.body.addEventListener('keydown', this.handleKeydown);
      }
    } else if (!isOpen && prevProps.isOpen) {
      if (__TEST__ || __CLIENT__) {
        document.body.removeEventListener('click', this.handleOutsideClick);
        document.body.removeEventListener('keydown', this.handleKeydown);
      }
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleOutsideClick);
    document.body.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown = event => {
    const { onClose } = this.props;

    if (event.key === 'Escape') {
      onClose();
    }
  };

  handleOutsideClick = event => {
    const { isOpen, onClose } = this.props;

    if (this.rootEl) {
      const ignoreClicksOnEl = [this.rootEl, this.rootEl.parentNode];
      if (isOpen && ignoreClicksOnEl.every(el => !el || !el.contains(event.target))) {
        onClose();
      }
    }
  };

  createPortal(child) {
    return ReactDOM.createPortal(child, document.querySelector('#content'));
  }

  render() {
    const { className, children, contentClassName, contentRef, contentProps, isMobile, isOpen, onClose } = this.props;

    const wrappedChildren = (
      <div
        className={cx(css.panel, className, {
          [css.isHidden]: !isOpen,
        })}
        ref={el => (this.rootEl = el)}>
        <div className={css.background} onClick={onClose} onTouchStart={onClose} />
        <div className={cx(css.content, contentClassName)} ref={contentRef} {...contentProps}>
          {children}
        </div>
      </div>
    );

    if ((__CLIENT__ || __TEST__) && isMobile) {
      return this.createPortal(wrappedChildren);
    }

    return wrappedChildren;
  }
}

Panel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  contentClassName: PropTypes.string,
  contentRef: PropTypes.object,
  contentProps: PropTypes.object,
  isMobile: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export { Panel };
